<template>
  <div class="row justify-content-center">
    <div class="col align-content-center">
      <img src="/assets/images/minLoader.gif" class="w-25" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "miniloader"
}
</script>